import { replicaStore } from 'entities/tavus/replica/model/replicaStore';
import { AvatarList } from './AvatarsList';
import React, { useMemo, useState, useEffect } from 'react';
import { AvatarSearchInput } from './AvatarSearchInput';
import Divider from 'components/Divider';
import { cn } from 'shared/lib';
import { FiltersDropdown } from './FiltersDropdown';
import { Replica } from 'entities/tavus/replica';
import { useLocation } from 'react-router';
import { AVATARS_CREATE_PERSONA_ROUTE } from 'shared/model';
import { tavusPersonaStore } from 'entities/tavus/persona';

export const AvatarChoose = () => {
  const [replicaNameFilter, setReplicaNameFilter] = useState('');
  const { pathname } = useLocation();
  const { setContainPreview } = tavusPersonaStore();

  const {
    replicasLoading,
    filteredReplicas,
    setCurrentReplica,
    currentReplica
  } = replicaStore((state) => ({
    replicasLoading: state.replicasLoading,
    filteredReplicas: state.filteredReplicas,
    setCurrentReplica: state.setCurrentReplica,
    currentReplica: state.currentReplica
  }));

  const replicas: Replica[] | null | undefined = useMemo(() => {
    if (!replicaNameFilter.trim()) {
      return filteredReplicas;
    }
    return filteredReplicas?.filter((replica) => {
      const name = replica?.yepic_name || replica?.replica_name;
      return name
        ?.toLowerCase()
        .includes(replicaNameFilter.trim().toLowerCase());
    });
  }, [filteredReplicas, replicaNameFilter]);

  useEffect(() => {
    if (pathname.includes(AVATARS_CREATE_PERSONA_ROUTE)) {
      if (
        !replicasLoading &&
        replicas &&
        replicas.length > 0 &&
        !currentReplica
      ) {
        setCurrentReplica(replicas[0]);
        if (
          replicas[0]?.yepic_avatar_type === 'Full Body' ||
          replicas[0]?.yepic_avatar_type === 'Video Call'
        ) {
          setContainPreview(false);
        } else if (replicas[0]?.yepic_avatar_type === 'Vertical Selfie') {
          setContainPreview(true);
        }
      }
    }
  }, [replicasLoading, replicas, currentReplica, setCurrentReplica]);

  return (
    <div className="ag-h-full ag-flex ag-flex-col">
      <div className="ag-flex ag-flex-col ag-gap-y-4">
        <AvatarSearchInput setReplicaNameFilter={setReplicaNameFilter} />
        <div className="ag-text-lg ag-font-semibold ag-gap-2 ag-text-gray-700 ag-flex ag-flex-col lg:ag-flex-row ag-items-center ag-justify-between ">
          <p className="ag-w-full">Choose Avatar</p>
          <div className="ag-w-full lg:ag-w-auto">
            <FiltersDropdown />
          </div>
        </div>
        <Divider className="" />
      </div>

      <div
        className={cn(
          'ag-flex-1 lg:ag-max-h-[80vh] ag-overflow-auto ag-relative'
        )}
      >
        {replicas?.length === 0 && !replicasLoading ? (
          <div className="ag-flex ag-justify-center ag-items-center ag-h-full">
            <span className="ag-text-gray-500 ag-text-lg">
              No avatars found
            </span>
          </div>
        ) : null}
        <div className="ag-absolute ag-inset-0 ag-overflow-y-auto">
          <AvatarList
            setSelectedReplica={setCurrentReplica}
            selectedReplica={currentReplica}
            replicasLoading={replicasLoading}
            replicas={replicas || []}
          />
        </div>
      </div>
    </div>
  );
};
